/* oxlint-disable */
// hooks/useSolitics.ts

'use client';

import { useEffect } from 'react';

import { useAuthStore } from '@/stores/userStore';

import { useAuth } from '@/core/auth/client/AuthProvider';

export const useSolitics = () => {
  const { session } = useAuth();
  const { account, setSoliticsInitialized, isSoliticsInitialized } = useAuthStore();

  useEffect(() => {
    if (session?.user?.id && account?.email && !isSoliticsInitialized()) {
      try {
        if (typeof window !== 'undefined' && (window as any).$solitics) {
          const loginObj = {
            memberId: session.user.id,
            email: account.email,
            brand: process.env.NEXT_PUBLIC_SOLITICS_BRAND_ID,
            popupToken: process.env.NEXT_PUBLIC_SOLITICS_POPUP_TOKEN,
            branch: process.env.NEXT_PUBLIC_SOLITICS_BRANCH,
          };

          (window as any).$solitics.loginSuccess(loginObj);
          setSoliticsInitialized();
        }
      } catch (error) {
        console.warn('Solitics initialization failed:', error);
      }
    }
  }, [session?.user?.id, account?.email, isSoliticsInitialized, setSoliticsInitialized]);
};
